<template>
  <div class="wh-wrap">
    <ProgressBar v-if="loader" mode="indeterminate"
      style="height:3px;position:fixed;top:0;left:0;right:0;z-index:9999;border-radius:0"/>

    <!-- ── Selección de empresa (Generador puede trabajar con varias transportadoras) ── -->
    <div class="wh-empresa-selector" v-if="idRolActivo == 2 && customer_selected == null">
      <div class="wh-empresa-icon"><i class="pi pi-building"></i></div>
      <div class="wh-empresa-body">
        <div class="wh-empresa-title">Seleccione la empresa de transporte</div>
        <Dropdown v-model="customer_selected" :showClear="true"
          :options="customers_group" optionLabel="name" optionValue="id_customer"
          placeholder="Seleccione una empresa…" style="width:100%;max-width:420px"
          @change="onEmpresaSeleccionada" />
      </div>
    </div>

    <template v-if="idRolActivo != 2 || customer_selected != null">

    <!-- ── Topbar ── -->
    <div class="wh-topbar">
      <div>
        <h2 class="wh-title">Webhooks</h2>
        <p class="wh-sub">Configuración de integraciones salientes por webhook</p>
      </div>
      <div class="wh-topbar-actions">
        <button class="wh-btn-outline" @click="toggle">
          <i class="pi pi-filter"></i> Filtrar
        </button>
        <button class="wh-btn-primary" @click="openModalNuevoWebhook">
          <i class="pi pi-plus"></i> Agregar webhook
        </button>
      </div>
    </div>

    <!-- ── Panel filtros ── -->
    <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" :style="{width:'420px'}">
      <div class="wh-filtros">
        <div class="wh-filtros-title"><i class="pi pi-filter"></i> Buscar webhook</div>
        <div class="wh-filtros-field">
          <label>URL</label>
          <InputText v-model="frmfiltros.url" placeholder="https://..." />
        </div>
        <div class="wh-filtros-field">
          <label>Estado</label>
          <Dropdown v-model="frmfiltros.status" :options="statusOptions"
            optionLabel="label" optionValue="value" placeholder="Todos los estados" />
        </div>
        <div class="wh-filtros-actions">
          <button class="wh-btn-outline" @click="limpiar">
            <i class="pi pi-filter-slash"></i> Limpiar
          </button>
          <button class="wh-btn-primary" @click="loadWebhooks(1)">
            <i class="pi pi-search"></i> Buscar
          </button>
        </div>
      </div>
    </OverlayPanel>

    <!-- ── Tabla webhooks ── -->
    <div class="wh-tabla-wrap">
      <table class="wh-tabla">
        <thead>
          <tr>
            <th>URL</th>
            <th>Token</th>
            <th>Estado</th>
            <th>Fecha creación</th>
            <th>Última actualización</th>
            <th style="width:110px">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="webhooks.length === 0 && !loader">
            <td colspan="6" class="wh-empty">
              <i class="pi pi-bolt"></i>
              <p>No se encontraron webhooks configurados</p>
            </td>
          </tr>
          <tr v-for="(w, i) in webhooks" :key="i">
            <td>
              <div class="wh-url-wrap">
                <div class="wh-url-icon"><i class="pi pi-link"></i></div>
                <span class="wh-url">{{ w.url }}</span>
              </div>
            </td>
            <td>
              <div class="wh-token-wrap">
                <span class="wh-token">{{ truncarToken(w.token) }}</span>
                <button class="wh-btn-icon" title="Copiar token" @click="copiarToken(w.token)">
                  <i class="pi pi-copy"></i>
                </button>
              </div>
            </td>
            <td>
              <span :class="['wh-badge', w.status == 1 ? 'wh-badge--verde' : 'wh-badge--rojo']">
                {{ w.status == 1 ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td class="wh-fecha">{{ formatDate(w.created_at) }}</td>
            <td class="wh-fecha">{{ formatDate(w.updated_at) }}</td>
            <td>
              <div class="wh-acciones">
                <button class="wh-btn-icon" title="Editar webhook" @click="editarWebhook(w)">
                  <i class="pi pi-pencil"></i>
                </button>
                <button class="wh-btn-icon wh-btn-icon--danger" title="Eliminar webhook"
                        @click="eliminarWebhook(w)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Skeleton -->
      <template v-if="loader && webhooks.length === 0">
        <div class="wh-skeleton-wrap">
          <div v-for="n in 5" :key="n" class="wh-skeleton-row"></div>
        </div>
      </template>

      <div class="wh-pagination">
        <span>{{ pagination.from }}–{{ pagination.to }} de {{ pagination.total }} webhooks</span>
        <Paginator :v-model:first="pagination.from" :rows="pagination.per_page"
          :rowsPerPageOptions="[15]" :totalRecords="pagination.total"
          @page="onChangePage($event)" class="wh-paginator" />
      </div>
    </div>

    <!-- ══ MODAL CREAR / EDITAR WEBHOOK ══ -->
    <Dialog v-model:visible="modal_webhook" :style="{width:'560px'}"
            :header="titulo_modal" :modal="true" class="wh-dialog">
      <div class="wh-modal-body">

        <div class="wh-modal-section">
          <div class="wh-modal-section-label">
            <i class="pi pi-bolt"></i> Información del webhook
          </div>

          <div class="wh-form-field">
            <label>URL webhook <span class="wh-required">*</span></label>
            <InputText v-model="frmWebhook.url" placeholder="https://midominio.com/webhook"
              :class="{'p-invalid': submitted && formErrors.url}" />
            <span class="wh-error" v-if="submitted && formErrors.url">{{ formErrors.url }}</span>
          </div>

          <div class="wh-form-field">
            <label>Token <span class="wh-required">*</span></label>
            <div class="wh-token-generar">
              <InputText v-model="frmWebhook.token" readonly placeholder="Genere un token para este webhook"
                :class="{'p-invalid': submitted && !frmWebhook.token}" />
              <button class="wh-btn-outline" type="button" @click="generarToken">
                <i class="pi pi-refresh"></i> Generar token
              </button>
            </div>
            <span class="wh-error" v-if="submitted && !frmWebhook.token">Debe generar un token</span>
          </div>

          <div class="wh-form-field">
            <label>Estado <span class="wh-required">*</span></label>
            <Dropdown v-model="frmWebhook.status" :options="estadoOptions"
              optionLabel="label" optionValue="value" placeholder="Seleccione" />
          </div>
        </div>

      </div>
      <template #footer>
        <button class="wh-btn-outline" @click="cerrarModal">
          <i class="pi pi-times"></i> Cancelar
        </button>
        <button class="wh-btn-primary" :disabled="loader" @click="guardarWebhook">
          <i :class="frmWebhook.id == 0 ? 'pi pi-save' : 'pi pi-check'"></i>
          {{ frmWebhook.id == 0 ? 'Crear webhook' : 'Guardar cambios' }}
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL ELIMINAR WEBHOOK ══ -->
    <Dialog v-model:visible="deleteWebhook" :style="{width:'440px'}"
            header="Eliminar webhook" :modal="true" class="wh-dialog">
      <div class="wh-modal-body">
        <div class="wh-confirm-body">
          <div class="wh-confirm-icon wh-confirm-icon--danger">
            <i class="pi pi-trash"></i>
          </div>
          <div>
            <p class="wh-confirm-question">¿Está seguro de eliminar este webhook?</p>
            <p class="wh-confirm-sub">{{ webhookSeleccionado?.url }}</p>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="wh-btn-outline" @click="deleteWebhook = false">
          <i class="pi pi-times"></i> Cancelar
        </button>
        <button class="wh-btn-danger" :disabled="loader" @click="confirmarEliminarWebhook">
          <i class="pi pi-trash"></i> Eliminar webhook
        </button>
      </template>
    </Dialog>

    </template>

  </div>
</template>

<script>
export default {
	data() {
		return {
			idRolActivo: null,
			customers_group: [],
			customer_selected: null,
			webhooks: [],
			loader: false,
			submitted: false,
			modal_webhook: false,
			deleteWebhook: false,
			titulo_modal: '',
			webhookSeleccionado: null,
			frmWebhook: {
				id: 0,
				url: '',
				token: '',
				status: 1
			},
			pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 15,
				to: 0,
				total: 0
			},
			formErrors: {
				url: ''
			},
			frmfiltros: {
				url: '',
				status: null
			},
			statusOptions: [
				{ label: 'Todos', value: null },
				{ label: 'Activo', value: 1 },
				{ label: 'Inactivo', value: 0 }
			],
			estadoOptions: [
				{ label: 'Activo', value: 1 },
				{ label: 'Inactivo', value: 0 }
			]
		}
	},
	watch: {
		'frmWebhook.url'(val) {
			if (!val) {
				this.formErrors.url = 'La URL del webhook es requerida';
			} else if (!/^https?:\/\/.+/.test(val)) {
				this.formErrors.url = 'Ingrese una URL válida (debe iniciar con http:// o https://)';
			} else {
				this.formErrors.url = '';
			}
		}
	},
	mounted(){
		const cookie = {};
		document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
		this.idRolActivo = cookie['IdRol'] ?? null;
		if (String(this.idRolActivo) === '2') {
			this.cargarEmpresas();
		} else {
			this.loadWebhooks(1);
		}
	},
	methods:{
		cargarEmpresas() {
			this.loader = true;
			const cookie = {};
			document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
			window.api.call('post', '/cargar_customers?&page=1', {
				email: cookie['Email'], id_rol: cookie['IdRol'],
			}).then(res => {
				if (res.status === 200) {
					this.customers_group = res.data.data;
					if (res.data.data.length === 1) {
						this.customer_selected = res.data.data[0].id_customer;
						this.loadWebhooks(1);
					} else {
						this.loader = false;
					}
				}
			}).catch(() => {
				this.loader = false;
				this.$toast.add({ severity:'error', summary:'Error', detail:'No se pudo cargar las empresas', life:5000 });
			});
		},
		onEmpresaSeleccionada() {
			if (this.customer_selected == null) return;
			this.loadWebhooks(1);
		},
        toggle(event) {
			this.$refs.op.toggle(event);
		},
        limpiar(){
			this.frmfiltros = { url: '', status: null };
			this.loadWebhooks(1);
		},
		truncarToken(token) {
			if (!token) return '';
			return token.length > 16 ? token.substring(0, 16) + '…' : token;
		},
		copiarToken(token) {
			navigator.clipboard.writeText(token).then(() => {
				this.$toast.add({ severity:'success', summary:'Copiado', detail:'Token copiado al portapapeles', life: 3000 });
			}).catch(() => {
				this.$toast.add({ severity:'error', summary:'Error', detail:'No se pudo copiar el token', life: 3000 });
			});
		},
		formatDate(dateString) {
			if (!dateString) return '—';
			return new Date(dateString).toLocaleDateString('es-CO', {
				day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit'
			});
		},
		loadWebhooks(page){
			this.loader = true;
			var _that = this;
			this.webhooks = [];
			const cookie = {};
			document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });

			window.api.call('post', '/load_webhooks?&page='+page, {
				email: cookie['Email'], id_rol: cookie['IdRol'], id_customer: this.customer_selected,
				frmfiltros: this.frmfiltros
			}).then( function(response) {
				if(response.status == 200){
					_that.pagination = response.data.data;
					_that.webhooks = response.data.data.data;
					_that.loader = false;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
				_that.$toast.add({severity:'error', summary: 'Error al cargar', detail: err.data?.error || 'Favor informar a un admin', life: 6000});
			});
		},
		onChangePage(page) {
			this.loadWebhooks((page.page+1));
		},
		openModalNuevoWebhook(){
            this.titulo_modal = 'Nuevo Webhook';
			this.submitted = false;
			this.frmWebhook = {
				id: 0,
				url: '',
				token: '',
				status: 1
			};
			this.modal_webhook = true;
		},
		editarWebhook(data){
            this.titulo_modal = 'Editar Webhook: ' + data.url;
			this.submitted = false;
			this.frmWebhook = { ...data };
			this.modal_webhook = true;
		},
		generarToken(){
			var _that = this;
			this.loader = true;
			const cookie = {};
			document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });

			window.api.call('post', '/generar_token_webhook', {
				email: cookie['Email'], id_rol: cookie['IdRol'], id_customer: this.customer_selected,
			}).then( function(response) {
				if(response.status == 200){
					_that.frmWebhook.token = response.data.token;
					_that.loader = false;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
				_that.$toast.add({severity:'error', summary: 'Error al generar token', detail: err.data?.error || 'No se pudo generar el token', life: 6000});
			});
		},
		cerrarModal() {
			this.modal_webhook = false;
			this.submitted = false;
		},
		guardarWebhook(){
			this.submitted = true;

			if(!this.frmWebhook.url || this.formErrors.url){
				this.$toast.add({
					severity:'error',
					summary: 'URL inválida',
					detail: this.formErrors.url || 'Ingrese la URL del webhook',
					life: 4000
				});
				return;
			}

			if(!this.frmWebhook.token){
				this.$toast.add({
					severity:'error',
					summary: 'Token requerido',
					detail:'Debe generar un token antes de guardar',
					life: 4000
				});
				return;
			}

			this.loader = true;
			var _that = this;
			const cookie = {};
			document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });

			window.api.call('post', '/guardar_webhook', {
				email: cookie['Email'], id_rol: cookie['IdRol'], id_customer: this.customer_selected,
				frmWebhook: this.frmWebhook
			}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.modal_webhook = false;
					_that.submitted = false;
					const accion = _that.frmWebhook.id == 0 ? 'creó' : 'actualizó';
					_that.$toast.add({
						severity: 'success',
						summary: 'Éxito',
						detail: `Se ${accion} el webhook correctamente`,
						life: 6000
					});
					_that.limpiar();
				}
			}).catch(function (err) {
                _that.loader = false;
				console.log(err);
				_that.$toast.add({
					severity:'error',
					summary: 'Error al guardar',
					detail: err.data?.error || 'Favor informar a un admin',
					life: 6000
				});
			});
		},
		eliminarWebhook(data){
			this.webhookSeleccionado = data;
			this.deleteWebhook = true;
		},
		confirmarEliminarWebhook(){
			this.loader = true;
			var _that = this;
			const cookie = {};
			document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });

			window.api.call('post', '/eliminar_webhook', {
				email: cookie['Email'], id_rol: cookie['IdRol'], id_customer: this.customer_selected,
				id_webhook: this.webhookSeleccionado.id
			}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.deleteWebhook = false;
					_that.$toast.add({
						severity: 'success',
						summary: 'Eliminado',
						detail: 'Se eliminó el webhook correctamente',
						life: 6000
					});
					_that.webhookSeleccionado = null;
					_that.limpiar();
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
				_that.$toast.add({
					severity:'error',
					summary: 'Error al eliminar',
					detail: err.data?.error || 'Favor informar a un admin',
					life: 6000
				});
			});
		}
	}
}
</script>

<style scoped lang="scss">
$navy:#0A354E; $white:#fff; $g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

.wh-wrap { background:$bg; min-height:100vh; padding:1.25rem .5rem; }

/* ── Selección de empresa ── */
.wh-empresa-selector { display:flex; align-items:center; gap:1rem; background:$white; border:1px solid $g200; border-radius:$r; padding:1.25rem 1.5rem; margin-bottom:1.25rem; }
.wh-empresa-icon { width:44px; height:44px; border-radius:10px; background:#eff6ff; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.2rem;color:#1e40af;} }
.wh-empresa-body { flex:1; }
.wh-empresa-title { font-size:.85rem; font-weight:700; color:$g700; margin-bottom:.5rem; }

/* ── Topbar ── */
.wh-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1.25rem; flex-wrap:wrap; gap:.75rem; }
.wh-title  { font-size:1.35rem; font-weight:700; color:$g700; margin:0 0 .2rem; }
.wh-sub    { font-size:.8rem; color:$g500; margin:0; }
.wh-topbar-actions { display:flex; gap:.65rem; }

/* ── Buttons ── */
.wh-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.wh-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }
.wh-btn-danger   { display:inline-flex; align-items:center; gap:.35rem; background:#dc2626; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; &:hover{background:#b91c1c;} &:disabled{opacity:.6;cursor:not-allowed;} }

.wh-btn-icon { display:inline-flex; align-items:center; justify-content:center; width:30px; height:30px; background:$white; border:1px solid $g200; border-radius:6px; cursor:pointer; color:$g700; font-size:.8rem; transition:all .15s; &:hover{border-color:$navy;color:$navy;} }
.wh-btn-icon--danger { &:hover{border-color:#dc2626;color:#dc2626;} }

/* ── Filtros ── */
.wh-filtros { padding:.25rem; }
.wh-filtros-title { display:flex; align-items:center; gap:.5rem; font-size:.9rem; font-weight:700; color:$navy; padding-bottom:.75rem; border-bottom:1px solid $g200; margin-bottom:.875rem; i{font-size:14px;} }
.wh-filtros-field { display:flex; flex-direction:column; gap:.3rem; margin-bottom:.875rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.wh-filtros-actions { display:flex; justify-content:flex-end; gap:.65rem; padding-top:.75rem; border-top:1px solid $g200; }

/* ── Tabla ── */
.wh-tabla-wrap { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; }
.wh-tabla { width:100%; border-collapse:collapse; font-size:.82rem; }
.wh-tabla thead tr { background:#f8f9fa; }
.wh-tabla th { text-align:left; padding:.65rem 1rem; font-size:.63rem; font-weight:700; letter-spacing:.7px; text-transform:uppercase; color:$g500; border-bottom:1px solid $g200; white-space:nowrap; }
.wh-tabla td { padding:.75rem 1rem; border-bottom:1px solid #f1f3f4; color:$g700; vertical-align:middle; }
.wh-tabla tbody tr:last-child td { border-bottom:none; }
.wh-tabla tbody tr:hover td { background:#fafbfc; }

/* Celdas */
.wh-url-wrap  { display:flex; align-items:center; gap:.5rem; }
.wh-url-icon  { width:28px; height:28px; border-radius:6px; background:#eff6ff; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:13px;color:#1e40af;} }
.wh-url       { font-size:.8rem; font-weight:500; color:$g700; word-break:break-all; }
.wh-token-wrap{ display:flex; align-items:center; gap:.4rem; }
.wh-token     { font-family:'Courier New',monospace; font-size:.75rem; color:$g500; background:#f8f9fa; padding:.2rem .5rem; border-radius:6px; }
.wh-fecha     { font-size:.78rem; color:$g500; white-space:nowrap; }
.wh-acciones  { display:flex; gap:.4rem; }

/* Badges */
.wh-badge { display:inline-flex; align-items:center; gap:.3rem; font-size:.72rem; font-weight:700; padding:.22rem .7rem; border-radius:20px; white-space:nowrap; }
.wh-badge--verde   { background:#f0fdf4; color:#166534; }
.wh-badge--rojo    { background:#fef2f2; color:#991b1b; }

/* Paginación */
.wh-pagination { display:flex; justify-content:space-between; align-items:center; padding:.75rem 1rem; border-top:1px solid $g200; font-size:.78rem; color:$g500; }
.wh-paginator  { background:transparent; border:none; }

/* Empty / skeleton */
.wh-empty { text-align:center; padding:3rem !important; color:$g500; i{font-size:1.75rem;display:block;margin-bottom:.75rem;} p{font-size:.875rem;} }
@keyframes shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
.wh-skeleton-wrap { padding:1rem; }
.wh-skeleton-row { height:56px; border-radius:8px; background:linear-gradient(90deg,#ececec 25%,#f5f5f5 50%,#ececec 75%); background-size:1200px; animation:shimmer 1.4s infinite linear; margin-bottom:.5rem; }

/* ── Modales ── */
.wh-dialog {
  :deep(.p-dialog-header) { font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:1.5rem; }
  :deep(.p-dialog-footer) { border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; gap:.65rem; }
}

.wh-modal-body { display:flex; flex-direction:column; gap:1.5rem; }
.wh-modal-section { display:flex; flex-direction:column; gap:.875rem; }
.wh-modal-section-label { display:flex; align-items:center; gap:.4rem; font-size:.82rem; font-weight:700; color:$navy; padding-bottom:.6rem; border-bottom:1px solid $g200; i{font-size:14px;} }

.wh-form-field { display:flex; flex-direction:column; gap:.3rem; label{font-size:.72rem; font-weight:700; color:$g500; text-transform:uppercase; letter-spacing:.5px;} }
.wh-required { color:#ef4444; }
.wh-error { font-size:.72rem; color:#dc2626; margin-top:.15rem; }

.wh-token-generar { display:flex; gap:.5rem; :deep(.p-inputtext) { flex:1; } .wh-btn-outline { white-space:nowrap; } }

/* Confirmar */
.wh-confirm-body { display:flex; align-items:flex-start; gap:1rem; padding:.5rem; }
.wh-confirm-icon { width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.3rem;} }
.wh-confirm-icon--danger  { background:#fef2f2; i{color:#dc2626;} }
.wh-confirm-question { font-size:.9rem; font-weight:600; color:$g700; margin:0 0 .35rem; }
.wh-confirm-sub      { font-size:.82rem; color:$g500; margin:0; word-break:break-all; }

/* Responsive */
@media(max-width:768px) {
  .wh-topbar { flex-direction:column; align-items:flex-start; }
  .wh-token-generar { flex-direction:column; align-items:stretch; }
}
</style>
